module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/component/footer.component.css
// module id = ./src/app/footer/component/footer.component.css
// module chunks = main